function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M5.5 1.5A2.5 2.5 0 003 4v24a2.5 2.5 0 002.5 2.5h21A2.5 2.5 0 0029 28V4a2.5 2.5 0 00-2.5-2.5h-21zm1.85 3A1.35 1.35 0 006 5.85v5.3c0 .746.604 1.35 1.35 1.35h17.3A1.35 1.35 0 0026 11.15v-5.3a1.35 1.35 0 00-1.35-1.35H7.35zm0 10.5A1.35 1.35 0 006 16.35v2.3c0 .746.604 1.35 1.35 1.35h2.3A1.35 1.35 0 0011 18.65v-2.3A1.35 1.35 0 009.65 15h-2.3zM6 23.85c0-.746.604-1.35 1.35-1.35h2.3c.746 0 1.35.604 1.35 1.35v2.3a1.35 1.35 0 01-1.35 1.35h-2.3A1.35 1.35 0 016 26.15v-2.3zM14.85 15a1.35 1.35 0 00-1.35 1.35v2.3c0 .746.604 1.35 1.35 1.35h2.3a1.35 1.35 0 001.35-1.35v-2.3A1.35 1.35 0 0017.15 15h-2.3zm-1.35 8.85c0-.746.604-1.35 1.35-1.35h2.3c.746 0 1.35.604 1.35 1.35v2.3a1.35 1.35 0 01-1.35 1.35h-2.3a1.35 1.35 0 01-1.35-1.35v-2.3zM22.35 15A1.35 1.35 0 0021 16.35v2.3c0 .746.604 1.35 1.35 1.35h2.3A1.35 1.35 0 0026 18.65v-2.3A1.35 1.35 0 0024.65 15h-2.3zM21 23.85c0-.746.604-1.35 1.35-1.35h2.3c.746 0 1.35.604 1.35 1.35v2.3a1.35 1.35 0 01-1.35 1.35h-2.3A1.35 1.35 0 0121 26.15v-2.3z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 5.75c0-.69.56-1.25 1.25-1.25h17.5c.69 0 1.25.56 1.25 1.25v5.5c0 .69-.56 1.25-1.25 1.25H7.25c-.69 0-1.25-.56-1.25-1.25v-5.5z",
  fill: "url(#calculations_svg__paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculations_svg__paint0_linear",
  x1: 9.75,
  y1: 4.5,
  x2: 22.126,
  y2: 11.575,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgCalculations = function SvgCalculations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgCalculations;